import type { ProductRegimeModel } from 'autogen/swagger/all';
import { create } from 'zustand';

export type RegimeState = {
    model?: ProductRegimeModel;
    setRegimeModel: (model: ProductRegimeModel) => void;
};

export const useRegimeStore = create<RegimeState>((set) => ({
    setRegimeModel: (model) => set((state) => ({ ...state, model }))
}));
